export default __webpack_public_path__ + "static/media/otterbg2.14aacf34.jpg";